import React from 'react';


import pdf from '../files/pdf.png'
import CVENpdf from '../files/cven.pdf'
import CVPLpdf from '../files/cvpl.pdf'
import LMENpdf from '../files/lmen.pdf'
import LMPLpdf from '../files/lmpl.pdf'

import {
    Button,
    Toolbar,
    Window,
    WindowHeader,
    WindowContent,
    Anchor ,
    Cutout
} from 'react95';

export const Docs = () => {
    return (
        <Window style={{ width: 550 , maxWidth: "75vw"}}>
            <WindowHeader>
          docs.exe
        </WindowHeader>
            <Toolbar>
                <Button variant='menu' size='sm'>
                    File
        </Button>
                <Button variant='menu' size='sm'>
                    Edit
        </Button>
                <Button variant='menu' size='sm' disabled>
                    Save
        </Button>
            </Toolbar>
            <WindowContent>
                <Cutout style={{ padding: '1rem', background: 'white', width: 'auto' }}>
                    <div className="container">
                        <div className="row">
                            {/* <div className="col-md-3 col-sm-6 col-6" >
                            <img src={pdf} className="img-thumbnail" style={{border: "none" }}/>
                            <a  href={CVENpdf} target = "_blank" className="text-center d-block">Resume English version</a >
                             </div>
                            <div className="col-md-3 col-sm-6 col-6">
                            <img src={pdf} className="img-thumbnail" style={{border: "none" }}/>
                            <a href={LMENpdf} className="text-center d-block">Motivation letter English version</a>
                            </div> */}
                            <div className="col-md-3 col-sm-6 col-6">
                            <img src={pdf} className="img-thumbnail" style={{border: "none" }}/>
                            <a href={CVPLpdf} target = "_blank" className="text-center d-block">Resume Polish version</a>
                            </div>
                            {/* <div className="col-md-3 col-sm-6 col-6">
                            <img src={pdf} className="img-thumbnail" style={{border: "none" }}/>
                            <a href={LMPLpdf} className="text-center d-block">Motivation letter Polish version</a>
                            </div> */}
                        </div>
                    </div>


                </Cutout>
            </WindowContent>
        </Window>
    );
}